import { render } from "./ManualsalesshootView.vue?vue&type=template&id=fb51fa74"
import script from "./ManualsalesshootView.vue?vue&type=script&lang=js"
export * from "./ManualsalesshootView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__